import React from "react";
import { NavLink } from "react-router-dom";
import Button from "../button/button";

// import "./NavigationItems.css";
import "./initiatives.css";

function InitiativesContainer(props) {
  return (
    <>
      <div id="initiativesPage" className="page">
        <h1>Initiatives</h1>
        <hr />
        {props.isAuth && (
          <Button design="raised" mode="accent" onClick={props.onAddInitiative}>
            New initiative
          </Button>
        )}
        <ul id="initiatives-items">{props.children}</ul>
      </div>
    </>
  );
}

export default InitiativesContainer;
